export enum OptimizationModesLabels {
	TargetRoas = 'Target ROAS',
	TargetCPA = 'Target CPA',
}
